/* eslint-disable import/no-unresolved */
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.4.1-2bW5h7N5TLEKpP3hb61d/mode=imports,min/optimized/keen-slider.js' // https://keen-slider.io/docs

class stickyMediaProductsCarousel extends window.BAO.CarouselElement {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.initialiseCarousel()
  }

  initialiseCarousel () {
    if (!this.els?.slides?.exists || !this.els?.slide?.exists) return
    return new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      drag: true,
      loop: false,
      mode: 'snap',
      slides: {
        origin: 'auto',
        perView: 1.9,
        spacing: 4,
      },
      breakpoints: {
        '(min-width: 900px)': {
          disabled: true,
        },
      },
    })
  }
}

if (!customElements.get('sticky-media-products-carousel')) {
  customElements.define(
    'sticky-media-products-carousel',
    stickyMediaProductsCarousel,
  )
}
